import React from "react";
import { Chip } from "@mui/material";
export const PastDeadlineChip = () => {
  return <Chip label={"Deadline passed"} color={"error"} />;
};
